<template>
  <div class="repeat-days-picker">
    <b-row class="repeat-date-row">
      <b-col md="6" class="repeat-date-col">
        <b-form-group label="Start date">
          <b-form-datepicker
            v-model="startDate"
            class="repeat-datepicker"
            placeholder="dd/mm/yyyy"
            locale="en-AU"
            today-button
            reset-button
            no-flip
            required
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
          />
        </b-form-group>
      </b-col>
      <b-col md="6" class="repeat-date-col">
        <b-form-group label="End date">
          <b-form-datepicker
            v-model="endDate"
            class="repeat-datepicker"
            placeholder="dd/mm/yyyy"
            locale="en-AU"
            today-button
            reset-button
            no-flip
            required
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-form-group label="Repeats on" class="repeat-days-group">
      <div class="repeat-day-buttons">
        <b-button
          v-for="day in dayOptions"
          :key="day.value"
          size="sm"
          class="repeat-day-button"
          :variant="days.includes(day.value) ? 'primary' : 'outline-secondary'"
          @click="toggleDay(day.value)"
        >
          {{ day.label }}
        </b-button>
      </div>
    </b-form-group>
  </div>
</template>

<script>
export const DAY_OPTIONS = [
  { value: 'mon', label: 'Mon' },
  { value: 'tue', label: 'Tue' },
  { value: 'wed', label: 'Wed' },
  { value: 'thu', label: 'Thu' },
  { value: 'fri', label: 'Fri' },
  { value: 'sat', label: 'Sat' },
  { value: 'sun', label: 'Sun' },
]

export default {
  name: 'RepeatDaysPicker',

  props: {
    value: {
      type: Object,
      default: () => ({ startDate: '', endDate: '', days: [] }),
    },
  },

  data() {
    return {
      dayOptions: DAY_OPTIONS,
    }
  },

  computed: {
    startDate: {
      get() {
        return this.value.startDate || ''
      },
      set(val) {
        this.$emit('input', { ...this.value, startDate: val })
      },
    },
    endDate: {
      get() {
        return this.value.endDate || ''
      },
      set(val) {
        this.$emit('input', { ...this.value, endDate: val })
      },
    },
    days() {
      return this.value.days || []
    },
  },

  methods: {
    toggleDay(day) {
      const next = this.days.includes(day)
        ? this.days.filter((d) => d !== day)
        : [...this.days, day]
      this.$emit('input', { ...this.value, days: next })
    },
  },
}
</script>

<style scoped>
.repeat-days-picker {
  margin-bottom: 0.9rem;
  padding: 1rem;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  background: #eff6ff;
}

.repeat-date-row {
  margin-right: -0.4rem;
  margin-left: -0.4rem;
}

.repeat-date-col {
  padding-right: 0.4rem;
  padding-left: 0.4rem;
}

.repeat-days-group {
  margin-bottom: 0;
}

.repeat-day-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.repeat-day-button {
  min-width: 48px;
  border-radius: 999px;
  font-weight: 700;
}

.repeat-days-picker /deep/ .form-group {
  margin-bottom: 1rem;
}

.repeat-days-picker /deep/ label,
.repeat-days-picker /deep/ legend {
  margin-bottom: 0.4rem;
  color: #1e3a8a;
  font-size: 0.75rem;
  font-weight: 700;
}

@media (max-width: 767px) {
  .repeat-date-col + .repeat-date-col {
    margin-top: 0.85rem;
  }
}

/* Match the job modal's inputs, and give the calendar popup a clear grey
   border + shadow so it doesn't blend into the card (the old native browser
   popup couldn't be styled at all). */
.repeat-days-picker /deep/ .repeat-datepicker.form-control {
  display: flex;
  align-items: center;
  min-height: 38px;
  border-color: #d1d5db;
  border-radius: 8px;
  background: #fff;
}

.repeat-days-picker /deep/ .repeat-datepicker .dropdown-menu {
  border: 1px solid #b7bec8;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(17, 24, 39, 0.12);
}
</style>
